import { ContactResponse } from '../dto/ResDtoRepository';
import { UpdateContactReq } from '../dto/ReqDtoRepository';
import { sendApiRequest, sendGetApiRequest } from './apiConfig';


export const getContact = async (aui: string): Promise<ContactResponse> => {
  return sendGetApiRequest<ContactResponse>(`/api/v1/contact?aui=${aui}`);
};

export const getContactForOwner = async (aui: string): Promise<ContactResponse> => {
  return sendApiRequest<ContactResponse>('get', `/api/v1/contact/owner?aui=${aui}`);
};

export const updateContact = async (aui: string, data: UpdateContactReq): Promise<ContactResponse> => {
  return sendApiRequest<ContactResponse>('put', `/api/v1/contact?aui=${aui}`, data);
};
